const create = (root: string) => {
  return {
    controlledTest: () => `${root}/create/controlled-test`,
    approximateExposure: () => `${root}/create/approximate-exposure`,
    fieldObservation: () => `${root}/create/field-observation`,
    odourObservation: () => `${root}/create/odour-observation`,
    airQualityObservation: () => `${root}/create/air-quality-observation`,
    disregard: () => `${root}/create/disregard`,
  };
};

const edit = (root: string) => {
  return {
    controlledTest: () => `${root}/edit/controlled-test/:id`,
    approximateExposure: () => `${root}/edit/approximate-exposure/:id`,
    fieldObservation: () => `${root}/edit/field-observation/:id`,
    odourObservation: () => `${root}/edit/odour-observation/:id`,
    airQualityObservation: () => `${root}/edit/air-quality-observation/:id`,
    disregard: () => `${root}/edit/disregard/:id`,
  };
};

export const annotationsRoutes = (root: string) => ({
  root,
  create: create(root),
  edit: edit(root),
});
